import Footer from '../home/Footer';

const SeratoHowTo = () => {
  return (
      <div>
          <div className={'infoPage'}>
              <h1>How to broadcast with Serato for free</h1>
              <p>
                  Coming soon...
              </p>
          </div>
          <Footer/>
      </div>
  );
};

export default SeratoHowTo;
